// Where the site footer does not render. Not on the Mae page on a phone: its composer
// is pinned to the bottom of the screen, and nothing may render behind or under it
// (the Mae drawer carries the site links). Pure.
export function footerHiddenOn(pathname: string, isMobile: boolean): boolean {
  return pathname.startsWith("/onboarding") || (isMobile && pathname.startsWith("/assistant-profile"));
}
